import React, { useEffect, useState } from "react";

import "./stylesTopFiveGames.css";
import ChartDataLabels from "chartjs-plugin-datalabels";

import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  BarElement,
  LineElement,
} from "chart.js";
import RebetLoader from "../../../CommonComponents/RebetLoader/RebetLoader";
import CustomDatePicker from "../../../CommonComponents/CustomDatePicker/CustomDatePicker";
import dayjs from "dayjs";

function TopFiveGames({ isApiRunning }) {
  const todayRange = [dayjs(), dayjs()];

  const [sportsBookDates, setSportsBookDates] = useState(todayRange);

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
  );

  const backgroundColorOptions = [
    "#3498DB",
    "#6177E8",
    "#9B59B6",
    "#BF3880",
    "#EE72BC",
    "#E74C3C",
  ];

  const borderColorOptions = [
    "#3498DB",
    "#6177E8",
    "#9B59B6",
    "#BF3880",
    "#EE72BC",
    "#E74C3C",
  ];

  const topFiveGamesData = {
    "Black Jack": 1000,
    Roulette: 800,
    "Footbal Studio": 600,
    "Black Bull": 400,
    "Buffalo King": 200,
    Other: 100,
  };

  const keys = Object.keys(topFiveGamesData);
  const values = Object.values(topFiveGamesData);

  const data = {
    labels: keys,
    datasets: [
      {
        label: "Number of Bets",
        data: values,
        backgroundColor: backgroundColorOptions,
        borderColor: borderColorOptions,
        borderWidth: 1,
        borderRadius: 4,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    scales: {
      x: {
        beginAtZero: true,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        anchor: "end",
        align: "start",
        formatter: (value) => value.toLocaleString() + " Bets",
        color: "#09090C",
        font: {
          family: "Poppins-regular",
          weight: "bold",
        },
      },
      tooltip: {
        enabled: true,
        mode: "nearest",
        intersect: false,
        backgroundColor: "#25252F",
        titleFont: {
          family: "Poppins-regular",
          size: 16,
          weight: "bold",
        },
        bodyFont: {
          family: "Poppins-regular",
          size: 14,
        },
        padding: 15,
        displayColors: true,
      },
    },
  };

  return (
    <div id="top-five-games-chart">
      <div className="top-five-games-chart-header">
        <h3>Top 5 Games</h3>
        {/* <CustomDatePicker
          getData={() => {}}
          dates={sportsBookDates}
          setDates={setSportsBookDates}
          showQuickSelect={false}
        /> */}
      </div>
      {isApiRunning ? (
        <RebetLoader width="100px" height="100px" />
      ) : (
        <div className="top-five-games-chart-body">
          <Bar data={data} options={options} />
        </div>
      )}
    </div>
  );
}

export default TopFiveGames;
